<script>

import Swal from "sweetalert2";
import moment from "moment/moment";
import {
  DxDataGrid,
  DxColumn,
  DxColumnChooser,
  DxColumnFixing,
  DxSelection,
  DxExport,
  DxStateStoring,
  DxGroupPanel,
  DxGrouping,
  DxPager,
  DxFilterRow,
  DxRemoteOperations
} from "devextreme-vue/data-grid";

export default {
  setup() {
    return { };
  },
  components: {
    DxDataGrid,
    DxColumn,
    DxColumnChooser,
    DxColumnFixing,
    DxSelection,
    DxExport,
    DxStateStoring,
    DxGroupPanel,
    DxGrouping,
    DxPager,
    DxFilterRow,
    DxRemoteOperations
  },
  props: {
    monitorasList: {
      type: Array,
      default: function () {
        return [];
      },
    },
    updating: {
      type: Boolean,
    },
  },
  mounted() {
    // console.log('mounted monitoras-table_0')
    // console.log(this.updating)
  },
  methods: {
    nomeStatus(value){
      const statusValue = value && value.value !== undefined ? value.value : value;
      let result = 'Não Definido'
      switch (statusValue) {
        case 'A':
          result = 'Ativo'
          break
        case 'Processado':
          result = 'Processado'
          break
        default:
          result = statusValue || 'Não Definido'
          break
      }
      return result
    },

    statusBadgeClass(value) {
      const statusValue = value && value.value !== undefined ? value.value : value;
      return statusValue === 'Processado' ? 'badge-soft-success' : 'badge-soft-danger';
    },

    attentionBadgeClass(value) {
      const attentionValue = value && value.value !== undefined ? value.value : value;
      return attentionValue === 'Processado' ? 'badge-soft-success' : 'badge-soft-danger';
    },

    detalhes(idData){
      console.log('detalhes_0: ' + idData)
      this.$router.push(`/monitora/detalhe/${idData}`);

    },

    editar(idData){
      console.log('editar: ' + idData)
      this.$router.push(`/movcompra/confirmar/${idData}`)
    },

    deletar(idData){
      console.log('deletar_0: ' + idData)
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Registro",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.$emit('deletareg', idData)
        }
      })
    },

    formatDateTime(value) {
      if(!value) {
        return '';
      }
      const format = "DD/MM/YYYY HH:mm:ss"
      const date = new Date(value);
      return moment(date).isValid() ? moment(date).format(format) : '';
    },

    formatDecimal(value) {
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return "0,00";
    },

    onRowDblClick(e) {
      if (e && e.data && e.data.monitora_id) {
        this.editar(e.data.monitora_id);
      }
    },

    numeroSigla(rowData) {
      return rowData && rowData.numero ? rowData.numero.substring(0, 5) : '';
    },

    changedSelection() {
      this.regSelecionado = this.$refs.monitoraDataGrid.instance.getSelectedRowsData();
      this.$emit('monitoraSelecionado', this.regSelecionado);
    }

  },
  data() {
    return {
      regSelecionado: {},

    };
  },
};
</script>

<template>
  <div class="mt-2">
    <DxDataGrid
        ref="monitoraDataGrid"
        :data-source="monitorasList"
        :show-borders="true"
        :focused-row-enabled="true"
        :keyExpr="'id'"
        :column-auto-width="true"
        :show-row-lines="true"
        :allow-column-reordering="true"
        :allow-column-resizing="true"
        :row-alternation-enabled="true"
        @selection-changed="changedSelection"
        @row-dbl-click="onRowDblClick"
    >
      <DxRemoteOperations
          :filtering="true"
          :paging="true"
          :sorting="true"
          :summary="true"
          :grouping="false"
          :group-paging="false"
      />

      <DxColumnChooser :enabled="true"/>
      <DxColumnFixing :enabled="true"/>
      <DxFilterRow :visible="true"/>
      <DxSelection mode="multiple"/>
      <DxExport :enabled="true" :allow-export-selected-data="true"/>
      <DxStateStoring :enabled="true" type="sessionStorage" storage-key="monitoraGrid"/>
      <DxGroupPanel :visible="true"/>
      <DxGrouping/>

      <!-- Colunas Monitora -->
      <DxColumn data-field="monitora_id"
                caption="ID"
                width="80"
                alignment="right"
                :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                :allowHeaderFiltering="false"/>

      <DxColumn data-field="nome"
                caption="Emitente"
                alignment="left"
                :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                :allowHeaderFiltering="false"/>

      <DxColumn data-field="emit"
                caption="Emit CNPJ"
                alignment="left"
                :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                :allowHeaderFiltering="false"/>

      <DxColumn data-field="dest"
                caption="Destinatário"
                alignment="left"
                :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                :allowHeaderFiltering="false"/>

      <DxColumn data-field="numero"
                caption="Número"
                alignment="left"
                :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                :allowHeaderFiltering="false"/>

      <DxColumn data-field="serie"
                caption="Série"
                alignment="left"
                :filter-operations="['=', '<>']"
                :allowHeaderFiltering="false"/>

      <DxColumn data-field="monitora_status"
                caption="Status"
                alignment="center"
                :filter-operations="['=', '<>']"
                :allowHeaderFiltering="false"/>

      <DxColumn data-field="dtemissao"
                caption="Emissão"
                alignment="right"
                data-type="datetime"
                :format="formatDateTime"
                :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                :allowHeaderFiltering="false"/>

      <!-- Colunas MovCompra -->
      <DxColumn data-field="empresa"
                caption="Empresa"
                alignment="center"
                :filter-operations="['=', '<>']"
                :allowHeaderFiltering="false"/>

      <DxColumn data-field="codigo"
                caption="Código"
                alignment="center"
                :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                :allowHeaderFiltering="false"/>

      <DxColumn data-field="valorliq"
                caption="Valor Líquido"
                alignment="right"
                :format="formatDecimal"
                :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                :allowHeaderFiltering="false"/>

      <DxColumn data-field="valorbrt"
                caption="Valor Bruto"
                alignment="right"
                :format="formatDecimal"
                :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                :allowHeaderFiltering="false"/>

      <DxColumn data-field="valorfrt"
                caption="Valor Frete"
                alignment="right"
                :format="formatDecimal"
                :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                :allowHeaderFiltering="false"/>

      <DxColumn data-field="peso"
                caption="Peso"
                alignment="right"
                :format="formatDecimal"
                :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                :allowHeaderFiltering="false"/>

      <DxColumn data-field="baseicms"
                caption="Base ICMS"
                alignment="right"
                :format="formatDecimal"
                :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                :allowHeaderFiltering="false"/>

      <DxColumn data-field="valoricms"
                caption="Valor ICMS"
                alignment="right"
                :format="formatDecimal"
                :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                :allowHeaderFiltering="false"/>

      <DxColumn data-field="chave"
                caption="Chave"
                alignment="center"
                :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                :allowHeaderFiltering="false"/>

      <DxColumn data-field="obs"
                caption="Observação"
                alignment="left"
                :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                :allowHeaderFiltering="false"/>


      <DxPager
          :visible="true"
          :show-page-size-selector="true"
          :allowed-page-sizes="[10, 30, 50, 100]"
          :show-navigation-buttons="true"
          :show-info="true"/>

    </DxDataGrid>
  </div>
</template>


